import api from 'api'
import { z } from 'zod'
import { WorkerRequirementId } from './types'

export const createPositionRequirementRequestSchema = z.object({
  name: z.string(),
  description: z.string(),
  category: z.string(),
  is_worker_visible: z.boolean(),
  is_company_specific: z.boolean(),
  position_id: z.number(),
})

type CreatePositionRequirementPayload = z.infer<
  typeof createPositionRequirementRequestSchema
>

export async function createPositionRequirement(
  payload: CreatePositionRequirementPayload
) {
  return api
    .post<WorkerRequirementId>(
      '/admin/positions/requirements',
      createPositionRequirementRequestSchema.parse(payload)
    )
    .then((response) => {
      return response.data
    })
}
